import React from 'react';
import {
    BooleanField,
    BooleanInput,
    Create,
    Datagrid,
    DateField,
    Edit,
    email,
    Filter,
    List,
    required,
    SelectInput,
    SimpleForm,
    TextField,
    TextInput,
} from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import { BulkDeleteButtonAdmin, CustomPagination, isAdmin, ToolbarSaveAllDeleteAdmin, stylesWide } from './utils';

const FranchiseeFilter = props => (
    <Filter {...props}>
        <SelectInput
            label="Поле"
            source="field"
            choices={[
                { id: 'id', name: 'Id франчайзи' },
                { id: 'name', name: 'Имя франчайзи' },
                { id: 'details', name: 'Подробности' },
                { id: 'email', name: 'Электронная почта' },
                { id: 'status', name: 'Статус' },
                { id: 'with_fine_fee', name: 'Учет штрафов' },
                { id: 'contact', name: 'Контакты' },
                { id: 'telegram_chat_id', name: 'Id Telegram-чата' },
                { id: 'succ_report_date', name: 'Последний отправленный отчет' },
                { id: 'created', name: 'Время создания' },
                { id: 'updated', name: 'Последнее обновление' },
            ]}
            alwaysOn
        />
        <TextInput
            label="Поиск"
            source="q"
            alwaysOn
        />
    </Filter>
);

export const FranchiseeList = ({ permissions, ...props }) => (
    <List
        {...props}
        filters={<FranchiseeFilter />}
        bulkActionButtons={<BulkDeleteButtonAdmin permissions={permissions} />}
        pagination={<CustomPagination />}
    >
        <Datagrid rowClick="edit">
            <TextField
                label="Id франчайзи"
                source="id"
            />
            <TextField
                label="Имя франчайзи"
                source="name"
            />
            <TextField
                label="Подробности"
                source="details"
            />
            <TextField
                label="Электронная почта"
                source="email"
            />
            <TextField
                label="Статус"
                source="status"
            />
            <BooleanField
                label="Учет штрафов"
                source="with_fine_fee"
            />
            <TextField
                label="Контакты"
                source="contact"
            />
            <TextField
                label="Id Telegram-чата"
                source="telegram_chat_id"
            />
            <DateField
                label="Последний отправленный отчет"
                source="succ_report_date"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Время создания"
                source="created"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Последнее обновление"
                source="updated"
                showTime
                locales="ru-RU"
            />
        </Datagrid>
    </List>
);


export const AddFranchisee = withStyles(stylesWide)(({classes, ...props}) => (
    <Create {...props} classes={classes}>
        <SimpleForm>
            <TextInput
                label="Имя франчайзи"
                source="name"
                validate={required()}
                classes={classes}
            />
            <TextInput
                label="Подробности"
                source="details"
                classes={classes}
            />
            <TextInput
                label="Электронная почта"
                source="email"
                validate={[email(), required()]}
                classes={classes}
            />
            <SelectInput
                label="Статус"
                source="status"
                choices={[
                    { id: 'active', name: 'active' },
                    { id: 'inactive', name: 'inactive' },
                ]}
                validate={required()}
                classes={classes}
            />
            <BooleanInput
                label="Учет штрафов"
                source="with_fine_fee"
                classes={classes}
            />
            <TextInput
                label="Контакты"
                source="contact"
                validate={required()}
                classes={classes}
            />
            <TextInput
                label="Id Telegram-чата"
                source="telegram_chat_id"
                classes={classes}
            />
        </SimpleForm>
    </Create>
));


export const EditFranchisee = withStyles(stylesWide)(({ classes, permissions, ...props }) => (
    <Edit {...props}>
        <SimpleForm toolbar={<ToolbarSaveAllDeleteAdmin permissions={permissions} />}>
            <TextInput
                disabled
                label="Id франчайзи"
                source="id"
                className={classes.wide}
            />
            <TextInput
                label="Имя франчайзи"
                source="name"
                validate={required()}
                className={classes.wide}
            />
            <TextInput
                label="Подробности"
                source="details"
                className={classes.wide}
            />
            <TextInput
                label="Электронная почта"
                source="email"
                validate={[email(), required()]}
                className={classes.wide}
            />
            <SelectInput
                label="Статус"
                source="status"
                choices={[
                    { id: 'active', name: 'active' },
                    { id: 'inactive', name: 'inactive' },
                ]}
                validate={required()}
                className={classes.wide}
            />
            <BooleanInput
                label="Учет штрафов"
                source="with_fine_fee"
                className={classes.wide}
            />
            <TextInput
                label="Контакты"
                source="contact"
                validate={required()}
                className={classes.wide}
            />
            <TextInput
                label="Id Telegram-чата"
                source="telegram_chat_id"
                className={classes.wide}
            />
            <hr></hr>
            {isAdmin(permissions) && (
                <BooleanInput
                    label="Показывать блок с поддержкой для партнеров франчайзи"
                    source="show_support_block"
                    className={classes.wide}
                />
            )}
            {isAdmin(permissions) && (
                <TextInput
                    label="Контакт поддержки партнеров франчайзи"
                    source="support_contact"
                    className={classes.wide}
                />
            )}
            <TextInput
                disabled
                label="Время создания"
                source="created"
                className={classes.wide}
            />
            <TextInput
                disabled
                label="Последнее обновление"
                source="updated"
                className={classes.wide}
            />
        </SimpleForm>
    </Edit>
));
